const EXT_BY_TYPE: Record<string, string> = {
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/webp': '.webp',
};

/**
 * Fetches a committed image (e.g. `/api/v1/media/…`, which 302s to a
 * presigned store URL — bucket CORS allows GET from web origins) back into
 * a File so it can be fed through ImageCropDialog for post-upload
 * adjustment. Rejects types the crop dialog can't round-trip through a
 * canvas (gif would lose animation).
 */
export async function fetchImageAsFile(url: string, baseName: string): Promise<File> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Image fetch failed: ${res.status}`);
  const blob = await res.blob();
  const ext = EXT_BY_TYPE[blob.type];
  if (ext === undefined) throw new Error(`Uncroppable image type: ${blob.type}`);
  return new File([blob], baseName + ext, { type: blob.type });
}
